<!-- Add by phone (ITP-E-198-01): the country, the number and the name; Call dials. -->
<section class="phone-invite" role="dialog" aria-label="Add by phone">
    <header class="phone-invite-header">
        <span class="phone-invite-title">Add by phone</span>
        <button type="button" class="phone-invite-close" (click)="onClose()" aria-label="Close add by phone" title="Close">
            <i class="fa-solid fa-xmark" aria-hidden="true"></i>
        </button>
    </header>

    <label class="phone-invite-label" [attr.for]="uid + '-search'">Country</label>
    <input [id]="uid + '-search'" class="phone-invite-input phone-invite-search" type="search" autocomplete="off"
           placeholder="Search countries" aria-label="Search countries" [value]="search"
           (input)="onSearch($any($event.target).value)">
    <!-- Only what the account dials; the user's own first where it is listed. -->
    <select class="phone-invite-input phone-invite-country" size="4" aria-label="Country"
            (change)="onCountry($any($event.target).value)">
        <option *ngFor="let each of shown; trackBy: trackCountry" [value]="keyOf(each)" [selected]="each === country">
            {{ each.name }} ({{ each.code }})
        </option>
    </select>
    <div class="phone-invite-hint" *ngIf="!countries.length">No countries can be dialled.</div>

    <label class="phone-invite-label" [attr.for]="uid + '-number'">Number</label>
    <div class="phone-invite-number">
        <span class="phone-invite-code" aria-hidden="true">{{ country?.code }}</span>
        <input [id]="uid + '-number'" class="phone-invite-input" type="tel" inputmode="tel" autocomplete="off" maxlength="24"
               placeholder="Phone number" [attr.aria-invalid]="numberInvalid" [attr.aria-describedby]="uid + '-number-error'"
               [value]="number" (input)="onNumber($any($event.target).value)" (keydown.enter)="onCall()">
    </div>
    <div class="phone-invite-error" [id]="uid + '-number-error'" *ngIf="numberInvalid" role="alert">
        Enter 4 to 15 digits.
    </div>

    <label class="phone-invite-label" [attr.for]="uid + '-name'">Name</label>
    <input [id]="uid + '-name'" class="phone-invite-input" type="text" autocomplete="off" [attr.maxlength]="maxName"
           placeholder="How they show in the call" [value]="name" (input)="onName($any($event.target).value)"
           (keydown.enter)="onCall()">

    <footer class="phone-invite-actions">
        <button type="button" class="phone-invite-cancel" (click)="onClose()">Cancel</button>
        <button type="button" class="phone-invite-call" (click)="onCall()" [disabled]="!canCall">
            <i class="fa-regular fa-phone" aria-hidden="true"></i>
            Call
        </button>
    </footer>
</section>
